module.exports = {
  "country": "UK",
  "artist": "Michael Ball",
  "song": "One Step Out Of Time",
  "year": "1992",
  "place": "2",
  "spotify": "7dpd5lxsIGY8v6SD1CChsX"
};